import { useEffect } from 'react'
import { initDatadogLogging, initDatadogRum } from '~/utils/datadog'

initDatadogRum()

const DatadogInit = () => {
  useEffect(() => {
    initDatadogLogging()
  }, [])

  return null
}

export default DatadogInit
